import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { currentTimeZone, timeZone } from 'src/app/app.constants';

/** Interface for legend items */
export interface LegendItem {
  map: string;
  icon: string;
  text: string;
  selected?: boolean;
}

export const DEFAULT_LEGENDS: LegendItem[] = [
  { map: 'regular', icon: 'calendar', text: 'Regular' },
  { map: 'overdue', icon: 'minus', text: 'Overdue' },
  { map: 'IsHoliday', icon: 'coffee', text: 'Holiday' },
  { map: 'IsRecurring', icon: 'redo', text: 'Recurring' },
  { map: 'IsReminder', icon: 'info', text: 'Reminder' },
  {
    map: 'IsFixedArrival',
    icon: 'clock-circle',
    text: 'Fixed arrival',
  },
  {
    map: 'days_to_delete',
    icon: 'minus-circle',
    text: 'Auto delete',
  },
];

@Component({
  selector: 'app-calendar-legend',
  templateUrl: './legend.component.html',
  styleUrl: './legend.component.scss',
  standalone: true,
  imports: [CommonModule, NzIconModule, NzButtonModule],
})
export class CalendarLegendComponent {
  @Output() selectionChange = new EventEmitter<string[]>();

  readonly currentTimeZone = currentTimeZone;
  readonly timeZone = timeZone;

  legends: LegendItem[] = [
    ...DEFAULT_LEGENDS.map(legend => ({ ...legend, selected: true })),
  ];

  /** Currently selected legend keys */
  get selected(): string[] {
    return this.legends.filter(l => l.selected).map(l => l.map);
  }

  /** Toggle selection state of a legend */
  toggleSelection(legend: LegendItem): void {
    if (this.allSelected) {
      this.deselectAll();
      legend.selected = true;
    } else {
      legend.selected = !legend.selected;

      if (this.noneSelected) {
        this.selectAll();
      }
    }

    this.selectionChange.emit(this.selected);
  }

  /** Helpers for selection state */
  get allSelected(): boolean {
    return this.legends.every(l => l.selected);
  }

  private get noneSelected(): boolean {
    return !this.legends.some(l => l.selected);
  }

  selectAll(): void {
    this.legends.forEach(l => (l.selected = true));
  }

  private deselectAll(): void {
    this.legends.forEach(l => (l.selected = false));
  }
}
